<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-autocomplete
                  :items="departmentList"
                  item-text="Name"
                  item-value="ID"
                  label="部門"
                  v-model="form.DepartmentID"
                  :rules="formRules.department"
                ></v-autocomplete>
                <v-autocomplete
                  :items="managerOptions"
                  item-text="Name"
                  item-value="ID"
                  label="負責人"
                  v-model="form.ManagerID"
                  :rules="formRules.manager"
                ></v-autocomplete>
                <v-text-field
                  v-model="form.Name"
                  label="名稱"
                  :rules="formRules.Name"
                ></v-text-field>
                <v-text-field
                  v-model="form.Amount"
                  label="預算"
                  :rules="formRules.budget"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                  :messages="BudgetConsumptionTips"
                ></v-text-field>
                <v-chip
                  v-show="isOverBudget"
                  color="red"
                  small
                >
                  預算超標
                </v-chip>
                <v-textarea
                  v-model="form.Remark"
                  rows="3"
                  label="備註"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="save"
        >儲存</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import TodoItemAutoComplete from "@/data/todo-item/TodoItemAutoComplete.js";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    editingId: {
      type: Number,
      required: true,
      default: -1
    },
    projectId: {
      type: Number,
      required: true
    },
    departmentId: {
      type: Number,
      required: false,
      default: null
    },
    stage: {
      type: String,
      required: true
    },
    projectDepartmentBudgetId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    form: {},
    defaultForm: {
      Amount: 0,
      Name: "",
      Remark: "",
      ManagerID: 0,
      DepartmentID: null
    }
  }),
  computed: {
    formRules() {
      return {
        amount: [
          v => v >= 0 || "預算不可以是負數",
          v => parseInt(v) <= 1000000000 || "預算不可超過10億"
        ],
        name: [v => !!v || "請輸入名稱"],
        manager: [v => !!v || "請選擇負責人"],
        department: [v => !!v || "請選擇部門"]
      };
    },
    formTitle() {
      return this.editingId === -1 ? "新增任務" : "編輯任務";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    managerOptions() {

      const findUserDepartment = user => {
        let departmentID = (
          this.userDepartments.find(o => o.UserID == user.ID) || {}
        ).DepartmentID;
        return this.departments.find(o => o.ID == departmentID) || {};
      };
      return this.activeUsers
        // .filter(
        //   o =>
        //     AppDataSetting.findUserLevel(this, o) <= 10 &&
        //     (this.myLevel > 10 ||
        //       findUserDepartment(o).ID == this.myDepartment.ID)
        // )
        .filter(o => findUserDepartment(o).Name) // 篩選有部門的人
        .map(o => ({ ID: o.ID, Name: `[${findUserDepartment(o).Name}] ${o.Profile.Name}` }));
    },
    editingIdx() {
      return this.$store.state.task.list.findIndex(o => o.ID == this.editingId);
    },
    projectDepartmentBudget() {
      return (
        this.projectDepartmentBudgets.find(
          o => o.ID == this.projectDepartmentBudgetId
        ) || {}
      );
    },
    BudgetConsumptionTips() {
      // let tasks = this.activeTaskList.filter(
      //   o => o.ProjectDepartmentBudgetID == this.projectDepartmentBudgetId
      // );
      // let taskUsedBudget = tasks.reduce((sum, item) => sum + item.Amount, 0);
      var tips = "";
      // 1. 專案部門預算
      // tips += `部門專案預算(${this.projectDepartmentBudget.ProjectStage}): ${this.projectDepartmentBudget.Budget}, 已編列 ${taskUsedBudget}`;
      //tips += `、\n`
      return tips;
    },
    isOverBudget() {
      let tasks = this.activeTaskList.filter(
        o => o.ProjectDepartmentBudgetID == this.projectDepartmentBudgetId
      );
      let taskUsedBudget = tasks.reduce((sum, item) => sum + item.Amount, 0);
      return (
        parseInt(taskUsedBudget) + parseInt(this.form.Amount) >
        this.projectDepartmentBudget.Budget
      );
    },
    departmentList() {
      if (this.form.DepartmentID > 0) {
        let idx = this.activeDepartmentList.findIndex(
          o => o.ID === this.form.DepartmentID
        );
        if (idx < 0) {
          var inactiveDepartment = this.$store.state.department.list.find(
            o => o.ID === this.form.DepartmentID
          );
          if (inactiveDepartment) {
            return [inactiveDepartment].concat(this.activeDepartmentList);
          }
        }
      }
      return this.activeDepartmentList;
    },
    ...mapGetters([
      "activeUsers",
      "userPositions",
      "userDepartments",
      "departments",
      "myDepartment",
      "myLevel",
      "tasks",
      "activeTaskList",
      "projectDepartmentBudgets",
      "taskWorkingItems",
      "activeDepartmentList"
    ])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) return;

      if (this.isOverBudget && !window.confirm(`預算超標，確定仍要新增?`))
        return;

      this.form.Amount = parseInt(this.form.Amount);

      this.isLoading = true;
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          this.isLoading = false;
          return alert("發生異常：無法找到編輯物件");
        }
        this.$services.task
          .edit(this, this.form)
          .then(res => {
            this.$set(
              this.$store.state.task.list,
              this.editingIdx,
              res.data.result
            );
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.form.ProjectID = this.projectId;
        this.form.ProjectStage = this.stage;
        // this.form.DepartmentID = this.departmentId;
        this.form.ProjectDepartmentBudgetID = this.projectDepartmentBudgetId;

        this.$services.task
          .add(this, this.form)
          .then(res => {
            this.$store.state.task.list.push(res.data.result);
            // 如果目前沒有符合的部門/階段的專案預算，重新抓取專案預算
            if (!this.$store.state.projectDepartmentBudget.list.find(o=>o.ProjectID == this.form.ProjectID && o.DepartmentID == this.form.DepartmentID && o.ProjectStage == this.form.ProjectStage)) {
              this.$store.state.projectDepartmentBudget.isFetched = false;
              this.$services.projectDepartmentBudget.prepareData(this);
            }
            this.$emit("updated", res.data.result);
            TodoItemAutoComplete.notifyActionDetected(this, 'projectDepartmentBudget', this.projectDepartmentBudgetId)
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetForm() {
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          alert("發生異常：無法找到編輯物件");
          return this.close();
        }
        this.form = JSON.parse( JSON.stringify(this.$store.state.task.list[this.editingIdx]))
      } else {
        this.form = Object.assign(
          JSON.parse(JSON.stringify(this.defaultForm)),
          {
            DepartmentID: this.departmentId
          }
        )
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>